import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Row,
  Col,
  CustomInput,
  Button,
  Label,
} from 'reactstrap'
import shortid from 'shortid'
import get from 'lodash/get'
import styled from 'styled-components'

class ChangeProjectStatusForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const changeProjectStatus = get(this.props, 'changeProjectStatus')
    const { clickChangeStatus } = this.props
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => clickChangeStatus('cancel') }
      >
        <ModalHeader
          toggle={ () => clickChangeStatus('cancel') }
        >
          <HeadLabel>Project Status</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col>
                        <CustomInputField
                          type='select'
                          value={ changeProjectStatus }
                          onChange={ (e) => this.props.handleStatus(e) }
                        >
                          { get(this.props, 'changeableProjectStatus', []).map((s) => (
                            <option key={ shortid() } value={ s }>{ s }</option>)
                          ) }
                        </CustomInputField>
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={ () => clickChangeStatus('apply') }>Apply</Button>
          <Button onClick={ () => clickChangeStatus('cancel') }>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

ChangeProjectStatusForm.propTypes = {
  handleStatus: PropTypes.func,
  clickChangeStatus: PropTypes.func,
}
ChangeProjectStatusForm.defaultProps = {
  handleStatus: () => {},
  clickChangeStatus: () => {},
}

export default ChangeProjectStatusForm

const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100%;
  height : 100%;
  font-size: 12px;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/change-project-status.js